module.exports = __webpack_public_path__ + "fonts/MyriadPro-BoldIt.7e64116a.otf";